import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'

import { AcEmbed, AcImage, AcTitle, AcTypography } from '@components'
import { useIsMd } from '@hooks/use-isMd'

// @ts-ignore
import { ISingleContentBlockEmbed, ISingleContentBlockImage } from '@typings'
import styles from '../../core/ac-richtext/ac-richtext.module.scss'

interface IACImageText {
  reverse?: boolean
  content: any
  image?: ISingleContentBlockImage
  embed?: ISingleContentBlockEmbed
}

export const AcRichTextLeftRight = observer(
  ({ content, image, embed, reverse = false }: IACImageText) => {
    const isMd = useIsMd()
    return (
      <Box
        sx={{
          display: {
            md: 'grid',
            xs: 'flex',
          },
          gridTemplateColumns: '1fr 1fr',
          gridGap: isMd ? '5rem' : '1.5rem',
          flexDirection: 'column',
        }}>
        <Box
          sx={{
            order: reverse && isMd ? 2 : 1,
          }}>
          {image && <AcImage {...image} />}
          {embed && <AcEmbed {...embed} />}
        </Box>
        <Box
          className={styles['ac-richtext']}
          sx={{
            display: 'flex',
            alignItems: 'center',
            order: reverse && isMd ? 1 : 2,
          }}>
          <Box
            sx={{
              'h1, h2, h3, h4': {
                color: 'var(--ac-palette-primary-main)',
              },
            }}>
            {content}
          </Box>
        </Box>
      </Box>
    )
  },
)
